/* eslint-disable react-hooks/exhaustive-deps */

import React, {useEffect, useState} from 'react';
import {makeStyles} from '@material-ui/core/styles';
import Paper from "@material-ui/core/Paper";
import {useMutation, useQuery} from "@apollo/react-hooks";
import FormControl from "@material-ui/core/FormControl";
import Grid from "@material-ui/core/Grid";
import TextField from "@material-ui/core/TextField";
import {WithContext as ReactTags} from 'react-tag-input';
import Typography from "@material-ui/core/Typography";
import {
    CREATE_ACCOUNT,
    GET_ACCOUNT,
    GET_ACCOUNTS_FIND_SIMILAR_NAMES,
    UPDATE_ACCOUNT
} from "../../database/queries/accountQueries";
import FormHelperText from "@material-ui/core/FormHelperText";
import Button from "@material-ui/core/Button";
import {tagDelimiters, tellParentMessage} from "../../utils/utils";
import usePersistentStore from "../../persistentStore";
import {notify} from "../../utils/notify";
import {useHistory, useParams} from "react-router-dom";
import InputAdornment from "@material-ui/core/InputAdornment";
import SearchOutlinedIcon from "@material-ui/icons/SearchOutlined";
import List from "@material-ui/core/List";
import Card from "@material-ui/core/Card";
import CardActionArea from "@material-ui/core/CardActionArea";
import CardContent from "@material-ui/core/CardContent";
import Moment from "react-moment";
import CalendarStrings from "../../constants/calendarStrings";
import {CREATE_WEB_HISTORY} from "../../database/queries/webHistoryQueries";
import {GET_USER_PREFERENCES, PREPEND_USER_PREFERENCE_LIST} from "../../database/queries/userPreferences";

const useStyles = makeStyles(theme => ({
    root: {
        flexGrow: 1,
        '& .ReactTags__tagInputField': {
            paddingLeft: 5,
            paddingRight: 5,
        },
    },
    leftField: {
        paddingRight: 10
    },
    middleField: {
        paddingLeft: 10,
        paddingRight: 10
    },
    rightField: {
        paddingLeft: 10,
    },
    title: {
        display: 'none',
        [theme.breakpoints.up('sm')]: {
            display: 'block',
        },
        marginRight: 10,
    },
    contactList: {
        '& .MuiCardContent-root': {
            padding: theme.spacing(1),
        }
    }
}));

const INITIAL_ACCOUNT = {
    accountId: '',
    accountName: '',
    accountLastName: '',
    accountLinkedinId: '',
    accountDescription: '',
    tags: []
};

const PopupAccountEdit = props => {
    const classes = useStyles();
    const [account, setAccount] = useState({...INITIAL_ACCOUNT}); // need this so we dont edit global account
    const [accountPossibleDupes, setAccountPossibleDupes] = useState([]);
    const [globalPersistentState, globalPersistentActions] = usePersistentStore();
    const [tagSuggestions] = useState([]);
    const [errors, setErrors] = useState({});
    const [searchText, setSearchText] = useState();
    const [linkedinId, setLinkedinId] = useState();
    const [dirty, setDirty] = useState(false);
    const [tagDirty, setTagDirty] = useState(false);
    let {parentId, selectionType} = useParams();
    // eslint-disable-next-line no-unused-vars
    const [confirmationOpen, setConfirmationOpen] = useState(false);
    const history = useHistory();

    if (!parentId && props.editId) parentId = props.editId;

    if (!selectionType && !window.location.pathname.endsWith('/edit')) {
        const segments = window.location.pathname.split('/');
        selectionType = segments.pop() || segments.pop();
    }

    const {data: getAccountsFindSimilarNamesData, refetch: getAccountsFindSimilarNamesRefetch} = useQuery(GET_ACCOUNTS_FIND_SIMILAR_NAMES, {
        skip: !searchText,
        variables: {name: searchText, limit: 5},
    });

    useEffect(() => {
        getAccountsFindSimilarNamesRefetch();
    }, [searchText]);

    useEffect(() => {
        if (getAccountsFindSimilarNamesData && getAccountsFindSimilarNamesData.accountsFindSimilarNames && getAccountsFindSimilarNamesData.accountsFindSimilarNames.length > 0) {
            setAccountPossibleDupes(getAccountsFindSimilarNamesData.accountsFindSimilarNames);
        }
    }, [getAccountsFindSimilarNamesData]);

    const {data: getAccountData, refetch: getAccountRefetch} = useQuery(GET_ACCOUNT, {
        skip: !parentId || parentId === 'new',
        variables: {accountId: parentId},
    });

    useEffect(() => {
        getAccountRefetch();
    }, [getAccountRefetch]);

    useEffect(() => {
        if (getAccountData && getAccountData.account) {
            let fetchedAccount = {...getAccountData.account};

            if (getAccountData.account.tagLinks) {
                let tags = [];
                getAccountData.account.tagLinks.map((tagLink) => {
                    const tag = {id: tagLink.tagId, text: tagLink.tag.tag};
                    tags.push(tag);
                    return tag;
                });
                fetchedAccount.tags = tags;
            }

            if (selectionType && selectionType === 'description' && globalPersistentState.popupQueryObj && globalPersistentState.popupQueryObj.selectionText) {
                if (fetchedAccount.accountDescription && fetchedAccount.accountDescription.length > 0) {
                    setConfirmationOpen(true);
                } else {
                    fetchedAccount.accountDescription = globalPersistentState.popupQueryObj.selectionText
                }
            }

            if ((!fetchedAccount.accountLinkedinId || fetchedAccount.accountLinkedinId === '') && linkedinId) fetchedAccount.accountLinkedinId = linkedinId;

            setAccount({...fetchedAccount});
            setAccountPossibleDupes([]);
            if (dirty) setDirty(false);
        }
    }, [getAccountData]);

    const [createAccount, {error: createAccountError}] = useMutation(CREATE_ACCOUNT);
    const [updateAccount, {error: updateAccountError}] = useMutation(UPDATE_ACCOUNT);

    const [prependUserPreferenceList] = useMutation(PREPEND_USER_PREFERENCE_LIST);
    const {refetch: getUserPreferencesRefetch} = useQuery(GET_USER_PREFERENCES, {
        skip: true,
        variables: {domain: 'popup'}
    });

    const [createWebHistory] = useMutation(CREATE_WEB_HISTORY);

    useEffect(() => {
        if (createAccountError) notify('createAccount', 'error', 'Problem creating account', null, null, globalPersistentState.popupQueryObj);
        if (updateAccountError) notify('updateAccount', 'error', 'Problem updating account', null, null, globalPersistentState.popupQueryObj);
    }, [createAccountError, updateAccountError]);

    useEffect(() => {
        if (globalPersistentState.popupQueryObj) {
            let matchedLinkedinId = '';

            if (globalPersistentState.popupQueryObj.selectionUrl) {
                const accountRegex = /linkedin\.com\/company\/([^/]+)/gi;
                const matches = accountRegex.exec(globalPersistentState.popupQueryObj.selectionUrl);
                if (matches && matches.length > 1) matchedLinkedinId = matches[1];
                setLinkedinId(matchedLinkedinId)
            }

            if (globalPersistentState.popupQueryObj.selectionText) {
                if (parentId && parentId === 'new') {
                    setSearchText(globalPersistentState.popupQueryObj.selectionText);
                }

                if (!parentId || parentId === 'new') {
                    const newAccount = {
                        accountName: globalPersistentState.popupQueryObj.selectionText,
                        accountLinkedinId: matchedLinkedinId
                    };
                    setAccount(newAccount);
                }
            }
        }
    }, []);

    const changeAccount = (field, value) => {
        const updatedAccount = {
            ...account,
            [field]: value
        };
        setAccount(updatedAccount);
        if (!dirty) setDirty(true);
    }

    const handleChange = (e) => {
        changeAccount(e.target.name, e.target.value)
    };

    const handleTagAddition = (newTag) => {
        if (!account.tags) account.tags = [];
        const tags = [...account.tags, newTag];
        const updatedAccount = {
            ...account,
            tags: tags
        };
        setAccount(updatedAccount);
        if (!dirty) setDirty(true);
        if (tagDirty) setTagDirty(false);
    };

    const handleTagDelete = (i) => {
        const tags = account.tags.filter((tag, index) => index !== i);
        const updatedAccount = {
            ...account,
            tags: tags
        };
        setAccount(updatedAccount);
        if (!dirty) setDirty(true);
    };

    const validateForm = () => {
        setErrors({});
        let newError = {};
        if (!account.accountName || account.accountName.length === 0) newError.accountName = 'Account First Name cannot be empty';

        if (Object.keys(newError).length > 0) {
            setErrors(newError);
            return false;
        } else {
            return true;
        }
    };

    return (
        <div className={classes.root}>
            {searchText && (
                <>
                    <FormControl
                        className={classes.formControl}
                        margin="dense"
                        size="small"
                        fullWidth
                    >
                        <TextField
                            id="searchEntry"
                            name="searchEntry"
                            label="Account Search"
                            fullWidth
                            size="small"
                            onChange={(e) => {
                                setSearchText(e.target.value);
                            }}
                            value={searchText ? searchText : ''}
                            InputProps={{
                                startAdornment: (
                                    <InputAdornment position="start">
                                        <SearchOutlinedIcon/>
                                    </InputAdornment>
                                ),
                            }}
                        />
                    </FormControl>
                    <List className={classes.accountList}>
                        {accountPossibleDupes.map(accountPossibleDupe => {
                            return (
                                <Card key={accountPossibleDupe.accountId}>
                                    <CardActionArea
                                        onClick={(e) => {
                                            setSearchText();
                                            setAccountPossibleDupes([]);
                                            notify('accountPossibleDupe', 'info', accountPossibleDupe.displayName + ' selected', null, null, globalPersistentState.popupQueryObj);
                                            const newLink = '/popup/account/' + accountPossibleDupe.accountId + '/edit';
                                            console.log('## SVR popupAccountEdit ## changing history', newLink);
                                            history.push(newLink);
                                        }}>
                                        <CardContent>
                                            <Typography variant="body1" color="textPrimary">
                                                {accountPossibleDupe.displayName}
                                                {accountPossibleDupe.linkedinId ? ' (linkedin: ' + accountPossibleDupe.linkedinId + ')' : ''}
                                            </Typography>
                                            <Typography variant="body2" color="textSecondary">
                                                Updated: <Moment
                                                calendar={CalendarStrings}>{accountPossibleDupe.updatedAt}</Moment>
                                            </Typography>
                                            <Typography variant="body2" color="textSecondary">
                                                {accountPossibleDupe.description}
                                            </Typography>
                                            {accountPossibleDupe.tags &&
                                            <Typography variant="body2" color="textSecondary">
                                                Tags: {accountPossibleDupe.tags.map(tag => tag.tag).join(', ')}
                                            </Typography>}
                                        </CardContent>
                                    </CardActionArea>
                                </Card>
                            )
                        })}
                        <Card>
                            <CardActionArea
                                onClick={(e) => {
                                    setSearchText();
                                    setAccountPossibleDupes([]);
                                }}>
                                <CardContent>
                                    <Typography variant="body1" color="textPrimary">
                                        Create New
                                        Account {globalPersistentState.popupQueryObj ? '- ' + globalPersistentState.popupQueryObj.selectionText : ''}
                                    </Typography>
                                </CardContent>
                            </CardActionArea>
                        </Card>
                    </List>
                </>
            )}
            {!searchText && account && (
                <div>
                    <Grid container className={classes.gridContainer}>
                        <Grid item xs={6} className={classes.middleField}>
                            <FormControl
                                className={errors.accountName ? classes.formControlError : classes.formControl}
                                margin="dense"
                                size="small"
                                fullWidth
                            >
                                <TextField
                                    required
                                    id="accountName"
                                    name="accountName"
                                    label="Name"
                                    fullWidth
                                    size="small"
                                    onChange={handleChange}
                                    value={account.accountName}
                                />
                                <FormHelperText>
                                    {errors.accountName}
                                </FormHelperText>
                            </FormControl>
                        </Grid>
                        <Grid item xs={6} className={classes.leftField}>
                            <FormControl
                                className={classes.formControl}
                                margin="dense"
                                size="small"
                                fullWidth
                            >
                                <TextField
                                    id="accountLinkedinId"
                                    name="accountLinkedinId"
                                    label="Linkedin Id"
                                    fullWidth
                                    size="small"
                                    onChange={handleChange}
                                    value={account.accountLinkedinId}
                                />
                            </FormControl>
                        </Grid>
                        <Grid item xs={12}>
                            <FormControl
                                className={classes.formControl}
                                margin="dense"
                                size="small"
                                fullWidth
                            >
                                <TextField
                                    id="accountDescription"
                                    name="accountDescription"
                                    label="Account description"
                                    fullWidth
                                    size="small"
                                    multiline
                                    rowsMax="3"
                                    value={account.accountDescription}
                                    onChange={handleChange}
                                />
                            </FormControl>
                        </Grid>
                        <Grid item xs={12} style={{marginBottom: 15}}>
                            <FormControl
                                className={classes.formControl}
                                margin="dense"
                                size="small"
                                fullWidth
                            >
                                <Typography variant="subtitle2" color="inherit">
                                    Tags
                                </Typography>
                                <Paper>
                                    <ReactTags tags={account.tags}
                                               suggestions={tagSuggestions}
                                               handleDelete={handleTagDelete}
                                               handleAddition={handleTagAddition}
                                               delimiters={tagDelimiters}/>
                                </Paper>
                            </FormControl>
                        </Grid>
                        <Grid item xs={6} className={classes.leftField}>
                            <Button
                                id={"btn-cancel"}
                                fullWidth={true}
                                variant="contained"
                                onClick={() => {
                                    globalPersistentActions.closePopup();
                                }}
                                color="secondary"
                            >
                                Cancel
                            </Button>
                        </Grid>
                        <Grid item xs={6} className={classes.rightField}>
                            <Button
                                id={"btn-save"}
                                fullWidth={true}
                                variant="contained"
                                color="primary"
                                disabled={tagDirty || !account.accountName || account.accountName.lenth === 0}
                                onClick={() => {
                                    if (validateForm()) {
                                        if (account.accountId) {
                                            const changedAccount = {
                                                accountId: account.accountId,
                                                accountName: account.accountName,
                                                accountLinkedinId: account.accountLinkedinId,
                                                accountDescription: account.accountDescription,
                                                tags: account.tags
                                            }
                                            updateAccount({
                                                variables: {changedAccount: changedAccount}
                                            }).then(async (updateResult) => {
                                                if (globalPersistentState.popupQueryObj && globalPersistentState.popupQueryObj.selectionUrl) {
                                                    await createWebHistory({
                                                        variables: {
                                                            newWebHistory: {
                                                                parentType: 'account',
                                                                parentId: account.accountId,
                                                                url: globalPersistentState.popupQueryObj.selectionUrl
                                                            }
                                                        }
                                                    })
                                                }
                                                prependUserPreferenceList({
                                                    variables: {
                                                        newListEntry: {
                                                            domain: 'popup',
                                                            key: 'recentAccountsList',
                                                            value: {
                                                                id: account.accountId,
                                                                name: updateResult.data.updateAccount.name
                                                            },
                                                            limit: 5
                                                        }
                                                    }
                                                }).then(prependResult => {
                                                    getUserPreferencesRefetch().then(fetchResult => {
                                                        tellParentMessage({userPreferences: fetchResult.data.userPreferences ? fetchResult.data.userPreferences : 'not logged in'}, globalPersistentState.popupQueryObj)
                                                        tellParentMessage({accountId: changedAccount.accountId}, globalPersistentState.popupQueryObj)
                                                        notify('updateAccount', 'info', 'Account updated', null, null, globalPersistentState.popupQueryObj);
                                                        console.log('## SVR popupAccountEdit ## changing history', '/popup/account/' + account.accountId + '/edit');
                                                        history.push('/popup/account/' + account.accountId + '/edit');
                                                    }).catch(e => {
                                                        console.trace(e);
                                                        notify('updateAccount', 'info', 'Account updated', null, null, globalPersistentState.popupQueryObj);
                                                        console.log('## SVR popupAccountEdit ## changing history', '/popup/account/' + account.accountId + '/edit');
                                                        history.push('/popup/account/' + account.accountId + '/edit');
                                                    });
                                                }).catch(e => {
                                                    console.trace(e);
                                                    notify('updateAccount', 'info', 'Account updated', null, null, globalPersistentState.popupQueryObj);
                                                    console.log('## SVR popupAccountEdit ## changing history', '/popup/account/' + account.accountId + '/edit');
                                                    history.push('/popup/account/' + account.accountId + '/edit');
                                                });
                                            }).catch(e => {
                                                notify('updateAccount', 'error', 'Problem updating account', null, null, globalPersistentState.popupQueryObj);
                                            })
                                        } else {
                                            createAccount({
                                                variables: {
                                                    newAccount: {
                                                        accountName: account.accountName,
                                                        accountLinkedinId: account.accountLinkedinId,
                                                        accountDescription: account.accountDescription,
                                                        tags: account.tags
                                                    }
                                                }
                                            }).then(async (createResult) => {
                                                if (globalPersistentState.popupQueryObj && globalPersistentState.popupQueryObj.selectionUrl) {
                                                    await createWebHistory({
                                                        variables: {
                                                            newWebHistory: {
                                                                parentType: 'account',
                                                                parentId: createResult.data.createAccount.id,
                                                                url: globalPersistentState.popupQueryObj.selectionUrl
                                                            }
                                                        }
                                                    })
                                                }
                                                prependUserPreferenceList({
                                                    variables: {
                                                        newListEntry: {
                                                            domain: 'popup',
                                                            key: 'recentAccountsList',
                                                            value: {
                                                                id: createResult.data.createAccount.id,
                                                                name: createResult.data.createAccount.name
                                                            },
                                                            limit: 5
                                                        }
                                                    }
                                                }).then(prependResult => {
                                                    getUserPreferencesRefetch().then(fetchResult => {
                                                        tellParentMessage({userPreferences: fetchResult.data.userPreferences ? fetchResult.data.userPreferences : 'not logged in'}, globalPersistentState.popupQueryObj)
                                                        tellParentMessage(!createResult.data || !createResult.data.createAccount ? {accountId: 'not found'} : {accountId: createResult.data.createAccount.id}, globalPersistentState.popupQueryObj)
                                                        notify('createAccount', 'info', 'Account created', null, null, globalPersistentState.popupQueryObj);
                                                        console.log('## SVR popupAccountEdit ## changing history', '/popup/account/' + createResult.data.createAccount.id + '/edit');
                                                        history.push('/popup/account/' + createResult.data.createAccount.id + '/edit');
                                                    }).catch(e => {
                                                        console.trace(e);
                                                        notify('createAccount', 'info', 'Account created', null, null, globalPersistentState.popupQueryObj);
                                                        console.log('## SVR popupAccountEdit ## changing history', '/popup/account/' + createResult.data.createAccount.id + '/edit');
                                                        history.push('/popup/account/' + createResult.data.createAccount.id + '/edit');
                                                    });
                                                }).catch(e => {
                                                    console.trace(e);
                                                    notify('createAccount', 'info', 'Account created', null, null, globalPersistentState.popupQueryObj);
                                                    console.log('## SVR popupAccountEdit ## changing history', '/popup/account/' + createResult.data.createAccount.id + '/edit');
                                                    history.push('/popup/account/' + createResult.data.createAccount.id + '/edit');
                                                });
                                            }).catch(e => {
                                                notify('createAccount', 'error', 'Problem creating account', null, null, globalPersistentState.popupQueryObj);
                                            })
                                        }
                                    }
                                }}
                            >
                                Save
                            </Button>
                        </Grid>
                    </Grid>
                </div>
            )}
        </div>
    )
};

export default PopupAccountEdit
